// extracted by mini-css-extract-plugin
export default {"root":"DownloadAppsButton_root__RlSGo","caption":"DownloadAppsButton_caption__taGNF","tooltip":"DownloadAppsButton_tooltip__zfgt8","active":"DownloadAppsButton_active__MvU+O"};